var _defs, _path, _g, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #28316d;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #00a44f;\n      }\n\n      .cls-3 {\n        fill: #f27921;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M340.88,397.78c-5.4,5.44-5.37,14.23.06,19.63l11.34,11.26c10.31,10.23,23.84,15.33,37.38,15.33,13.53,0,27.06-5.11,37.36-15.33,10.01-9.94,15.52-23.15,15.52-37.22,0-14.07-5.51-27.28-15.52-37.22l-41.73-41.4c-25.94-25.74-55.73-29.44-75.88-9.44-5.44,5.4-5.47,14.19-.07,19.63,5.4,5.44,14.19,5.47,19.63.07,11.86-11.76,28.12.87,36.77,9.44l41.72,41.39c4.72,4.68,7.31,10.91,7.31,17.52,0,6.61-2.59,12.84-7.31,17.52-9.82,9.75-25.8,9.74-35.63,0l-11.34-11.26c-5.44-5.4-14.24-5.37-19.63.06Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M356.33,68h-57.38c-15.84,0-28.69,12.84-28.69,28.69v57.38c0,15.84,12.84,28.69,28.69,28.69h57.38c15.84,0,28.69-12.84,28.69-28.69h0v-57.38c0-15.84-12.84-28.69-28.69-28.69ZM356.33,154.06h-57.38v-57.38h57.38v57.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M98.14,182.75h57.38c15.84,0,28.69-12.84,28.69-28.69v-57.38c0-15.84-12.84-28.69-28.69-28.69h-57.38c-15.84,0-28.69,12.84-28.69,28.69v57.38c0,15.84,12.84,28.69,28.69,28.69ZM98.14,154.06v-57.38h57.38v57.38h-57.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M155.51,268.82h-57.38c-15.84,0-28.69,12.84-28.69,28.69v57.38c0,15.84,12.84,28.69,28.69,28.69h57.38c15.84,0,28.69-12.84,28.69-28.69v-57.38c0-15.84-12.84-28.69-28.69-28.69ZM155.51,354.88h-57.38v-57.38h57.38v57.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M214.6,362.05c0,11.88,9.63,21.52,21.52,21.52,9.48,0,17.52-6.13,20.39-14.64l-27.43-27.21c-8.42,2.92-14.47,10.92-14.47,20.33Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 363.5,
    cy: 226.84,
    r: 21.52
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M270.1,194.96c-1.03-6.91-6.98-12.2-14.18-12.21-7.92,0-14.34-6.42-14.34-14.34v-86.06c0-7.92-6.42-14.35-14.34-14.35s-14.34,6.42-14.34,14.34v86.06c0,7.92-6.42,14.34-14.34,14.34h0c-7.92,0-14.34,6.42-14.34,14.34s-6.42,14.34-14.34,14.34h-28.69c-7.92,0-14.34,6.42-14.34,14.34s6.42,14.35,14.34,14.35h60.14c3.77-7.69,8.83-14.78,15.1-21.01,15.13-15.01,34.11-23.53,53.69-24.16Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 83.79,
    cy: 225.79,
    r: 14.34,
    transform: "translate(-156.87 216.8) rotate(-67.5)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M218.54,274.14c0,14.07,5.52,27.29,15.52,37.23l44.51,44.16c13.75,13.65,28.21,20.54,41.9,20.54,11.18,0,21.85-4.6,31.19-13.87,5.44-5.4,5.47-14.19.07-19.63-5.4-5.44-14.19-5.47-19.63-.07-4.07,4.04-13.62,13.52-33.98-6.67l-44.51-44.16c-4.72-4.68-7.32-10.91-7.32-17.53,0-6.61,2.6-12.84,7.32-17.52,8.87-8.8,22.46-13.07,32.84-2.76l14.12,14.02c5.44,5.4,14.23,5.37,19.63-.07s5.37-14.22-.07-19.63l-14.13-14.03c-20.04-19.88-50.3-18.72-71.95,2.76-10.01,9.94-15.53,23.16-15.53,37.23Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c00e33174669deb0b38983a81d8cf40c.svg";
export { ForwardRef as ReactComponent };